import { tourStep } from './tourRegistry';

export const bandaEncuestasSteps = [
  tourStep(
    'encuestas-header',
    'Encuestas y consultas',
    'Preguntas a la plantilla: votaciones, disponibilidad u opiniones. No es la encuesta de asistencia de una actuación.',
  ),
  tourStep(
    'encuestas-crear',
    'Crear encuesta',
    'Título, preguntas y a quién convocar (músicos o grupos). Ábrela cuando esté lista para que respondan.',
  ),
  tourStep(
    'encuestas-tabs',
    'Activas e histórico',
    '<strong>Activas</strong> son borradores y abiertas. El <strong>histórico</strong> guarda las ya cerradas con resultados.',
  ),
];
